/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/scenario-activity',['require','underscore','jquery','backbone','marionette','core/engine','screens/scenario-mapper/scenario'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var Marionette = require('marionette');

  var Engine = require('core/engine');
  var Scenario = require('screens/scenario-mapper/scenario');

  /*****************************************************************************************************************///}

  var ScenarioActivity = Marionette.LayoutView.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    el: '<div data-role="scenario-activity" class="scenario-activity">',
    template: _.template('<div data-role="activity-content" class="activity-content"></div>'),
    options: { },

    phases: null,
    phaseIndex: 0,
    phaseAttempts: 0,

    performance: 'good',
    location: null,
    audio: null,
    content: null,
    directionsEl: null,

    isReady: false,
    currentPhase: null,
    currentScene: null,

    radio: Backbone.Wreqr.radio.channel('global').vent,
    suspended: false,

    audioReady: false,
    imagesReady: false,
    totalAudios: 0,
    audiosLoaded: 0,
    imageAttempts: 0,
    maxAttempts: 10,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      this.suspended = false;

      this.template = options.template || this.template;

      //console.warn('SCENARIO ACTIVITY:', options);
      this.location = options.location;
      this.$el.addClass(options.addClass);
      this.options = options;//_.assign(this.options, this.model.get('options'));

      this.content = $.xml2json(options.xmlData, true);
      //console.log('content: ', this.content);
      this.phases = this.content.ContentCollection;

      this.$el.css('opacity', 0);

      this.audioReady = false;
      this.imagesReady = false;
     // this.setLayout();
     // this.setInterface();
    },

    setup: function($location)
    {
      this.location = $location;
      this.hideActiveHotspots();
      this.preloadAudio();
    },

    onRender: function()
    {
      //setTimeout(this.finish.bind(this), 2000);
      //console.log('RENDER RENDER RENDER');
    },

    onShow: function()
    {
      this.checkImgsReady();
      //$(this.get('.scene-container').get(0)).show();
    },

    begin: function()
    {
      this.$el.animate({'opacity': 1}, {duration: 350});
    },

    preloadAudio: function()
    {
      var $audioArr = [];
      var self = this;
      this.audiosLoaded = 0;

      $audioArr = this.findAudio(this.content);
      this.totalAudios = $audioArr.length;

      if (this.totalAudios > 0)
        this.updateActivityLoader(1 / this.totalAudios);
      else
        this.updateActivityLoader(0.5);

      if ($audioArr.length === 0)
        this.audioReady = true;

      _.each($audioArr, function($aObj) {
        self.tryLoadAudio($aObj);
      });
    },

    tryLoadAudio: function($aObj)
    {
      var self = this;
      $.ajax({
        url: 'content/audio/' + $aObj.filename
      }).fail(function() {
        self.radio.trigger('check.connection');
        //alert('fail');
      }).complete(function() {
        //console.log('load complete', arguments);
      }).always(
        $.proxy(self.audioLoaded, self)
      );
    },

    audioLoaded: function()
    {
      this.audiosLoaded++;
      this.updateActivityLoader();
      if (this.audiosLoaded === this.totalAudios)
      {
        this.audioReady = true;
        this.activityReady();
      }
    },

    updateActivityLoader: function(_perc)
    {
      _perc = _perc === undefined ? this.audiosLoaded / this.totalAudios : _perc;
      ////console.log('update activity loader in activity');
      this.trigger(Scenario.UPDATE_ACTIVITY_LOADING, _perc);
    },

    findAudio: function($data)
    {
      var $audioArr = [];
      ////console.log('find audio', $data, typeof $data);
      if (_.isPlainObject($data))
      {
        if ($data.ContentAudio)
          $audioArr = $audioArr.concat($data.ContentAudio);

        if ($data.ContentCollection)
          $audioArr = $audioArr.concat(this.findAudio($data.ContentCollection));

        if ($data.ContentObject)
          $audioArr = $audioArr.concat(this.findAudio($data.ContentObject));
      }
      else if (_.isArray($data))
      {
        _.each($data, function($obj) {
          $audioArr = $audioArr.concat(this.findAudio($obj));
        }, this);
      }

      return $audioArr;
    },

    checkImgsReady: function()
    {
      ////console.log('checkImgsReady', this.$el.find('[data-mc=mc]'));
      var self = this;
      var $imgsReady = _.all(this.$el.find('img'), function(img) {
        ////console.log('check img ready', img);
        if (!img.complete)
        {
          if (!img.imageAttempts)
            img.imageAttempts = 0;
          img.imageAttempts++;
        }
        return img.complete === true || img.imageAttempts >= self.maxAttempts;
      });

      if ($imgsReady === true)
      {
        this.imagesReady = true;
        this.activityReady();
      }
      else
      {
        _.delay($.proxy(this.checkImgsReady, this), 750);
      }
    },

    activityReady: function()
    {
      //console.log('activity ready', this.imagesReady, this.audioReady);
      if (!this.imagesReady || !this.audioReady)
        return;

      this.isReady = true;
      this.trigger(Scenario.ACTIVITY_READY, this);
    },

    setLayout: function()
    {

    },

    setInterface: function()
    {
      this.radio.trigger('ui.update', {help: false});
    },

    playAudio: function($id, $collection, $callback, $fallback)
    {
      $callback = $callback === undefined ? null : $callback;
      $fallback = $fallback === undefined ? null : $fallback;

      $collection = $collection || this.content;
      //console.log('playAudio ', $collection, $id);
      ////console.log(_.findWhere($collection, {'id': $id}));
      var $audioObj = _.findWhere($collection.ContentAudio, {'id': $id});

      if ($audioObj)
      {
        this.audio = this.createContentAudio($audioObj);
        this.playMedia(this.audio, null, $callback);
      }
      else if ($fallback !== null)
      {
        $fallback.apply(this);
      }
      else if ($callback !== null)
      {
        $callback.apply(this);
      }

      // _audio = $collection.getByID($id) as ContentAudio;

      // if (_audio)
      // {
      //   _audio.onComplete = $callback;
      //   _audio.play(false);
      // }
      // else if ($fallback != null)
      // {
      //   if ($fallback.length == 1)
      //     $fallback(new Event('null'));
      //   else
      //     $fallback();
      // }
      // else if ($callback != null)
      // {
      //   if ($callback.length == 1)
      //     $callback(new Event('null'));
      //   else
      //     $callback();
      // }
    },

    playMedia: function(media, options, callback)
    {
      //console.log('play media from scenario-activity', this.model, media, options);
      media = media || this.model.get('media');

      callback = callback || this.onMediaEnded;
      options = options || { };

      _.assign(options, _.omit(media, ['filename', 'caption', 'character']));

      ////console.log(options);

      if (media)
      {
        options.caption = {
          character: media.character,
          text: media.caption
        };

        if (this.channel)
          this.channel.off($.jPlayer.event.ended);

        this.channel = Engine.module('Media').play(media.filename, options);
        //this.channel.off($.jPlayer.event.ended);
        var self = this;
        self.channel.on($.jPlayer.event.ended, $.proxy(callback, self));
      }
      else
      {
        //console.log('No media found.');
      }
    },

    skipAudio: function()
    {
      if (this.channel)
        this.channel.skip();
    },

    stopMedia: function()
    {
      if (this.channel)
      {
        //this.channel.off($.jPlayer.event.ended);
        this.channel.cleanup();
      }
    },

    playSoundFX: function(filename, options)
    {
      if (!this.fxChannel)
        this.fxChannel = Engine.module('Media').openChannel();

      this.fxChannel.play(filename, options);
    },

    onMediaEnded: function(e)
    {
      ////console.log('BaseScreen::onMediaEnded');
    },

    suspend: function()
    {
      this.suspended = true;
      if (this.channel)
        this.channel.suspend();
    },

    resume: function(force)
    {
      this.suspended = false;
      if (this.channel)
        this.channel.resume(force);
    },

    get: function(selector)
    {
      return this.$el.find(selector);
    },

    onBeforeDestroy: function()
    {
      console.warn('DESTROY ACTIVITY');
      this.currentScene = null;

      if (this.channel)
      {
        this.channel.off($.jPlayer.event.ended);
        this.channel.cleanup(true);
      }

      if (this.fxChannel)
        this.fxChannel.destroy();

      if (this.model)
        this.model.destroy();
    },

    finish: function($performance)
    {
      $performance = $performance === undefined ? this.performance : $performance;
      //console.log('finish', this.performance, $performance);
      this.location.performance = $performance;
      this.trigger(Scenario.ACTIVITY_COMPLETE, this);
    },

    createContentAudio: function($audioObj)
    {
      ////console.log('createContentAudio');
      var $audio = {
        caption: $audioObj.line[0].text,
        character: $audioObj.line[0].character,
        filename: $audioObj.filename
      };

      return $audio;
    },

    updateScenarioAsset: function($assetName, $assetFrame)
    {
      var $item = Scenario.getItemByName($assetName);
      if ($item)
      {
        $item.frameName = $assetFrame;
        $item.updateFrames();
      }
    },

    hideActiveHotspots: function($ignoreArr)
    {
      Scenario.singleton.activeConversation.hideHotspots($ignoreArr);
    },

    clearObject: function($doc)
    {
      $doc.empty();
    },

    downgradePerformance: function()
    {
      if (this.performance === ScenarioActivity.PERFORMANCE_GOOD)
        this.performance = ScenarioActivity.PERFORMANCE_AVERAGE;
      else if (this.performance === ScenarioActivity.PERFORMANCE_AVERAGE)
        this.performance = ScenarioActivity.PERFORMANCE_POOR;
    },

    upgradePerformance: function()
    {
      if (this.performance === ScenarioActivity.PERFORMANCE_POOR)
        this.performance = ScenarioActivity.PERFORMANCE_AVERAGE;
      else if (this.performance === ScenarioActivity.PERFORMANCE_AVERAGE)
        this.performance = ScenarioActivity.PERFORMANCE_GOOD;
    },

    loadCurrentPhase: function()
    {
      //console.log('loading current phase');
      this.currentPhase = this.phases[this.phaseIndex];
      if (this.phaseIndex > this.phases.length - 1) // no more phases, finish the activity
      {
        this.finish();
        return;
      }

      this.phaseAttempts = 0;

      this.showScene(this.currentPhase.scene.toLowerCase());
      this.addDirections();

      if (this['setup' + this.currentPhase.scene] !== undefined)
        this['setup' + this.currentPhase.scene]();
      else
        console.error('Unknown phase: ' + this.currentPhase.scene);
    },

    showScene: function($sceneName)
    {
      //console.log('show scene ', $sceneName);
      $(this.get('.scene-container')).hide();
      this.currentScene = $(this.get('.scene-container[data-scene=' + $sceneName + ']'));
      this.currentScene.show();
    },

    addDirections: function()
    {
      if (!this.currentPhase)
        return;

      var $obj = _.findWhere(this.currentPhase.ContentText, {'id': 'textHolder.directions'});
      //var $obj = this.currentPhase.getByName('directions');
      //console.log('ADD DIRECTIONS', this.currentPhase, $obj);

      if ($obj && $obj.apply === 'true')
      {
        this.currentScene.find('[data-mc=textHolder] .directions-text').html($obj.text);
      }
    }

  /*****************************************************************************************************************///}

  });

  ScenarioActivity.PERFORMANCE_GOOD = 'good';
  ScenarioActivity.PERFORMANCE_AVERAGE = 'average';
  ScenarioActivity.PERFORMANCE_POOR = 'poor';

  return ScenarioActivity;

});

